// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2JyBc","label":"Section_label__3RuBH","contentWrap":"Section_contentWrap__1OX7Y","footer":"Section_footer___sSz3","footerInner":"Section_footerInner__1fqzw"};